module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/S7OPZF/tc-custom/9781625855299.jpg?1705026122863",
      "alt": "This image is the cover for the book New Jersey Fresh, American Palate"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("New Jersey Fresh, American Palate\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("New Jersey's bounty is ripe for the picking. The state boasts thousands of thriving farms, hundreds of CSAs, dozens of community farmers' markets and countless residents dedicated to the locavore lifestyle. Jersey food writer and chef Rachel J. Weston takes a seasonal tour of the state, showcasing the bounty that its down-to-earth farmers, creative artisan producers and innovative chefs produce for their patrons throughout the year. See how globally inspired cuisine representing New Jersey's diverse population is created and adapted using locally sourced products. Savor a juicy August peach, pucker up for a tart cranberry in October and nourish body and soul with local bok choy, asparagus and tomatoes. With local recipes for every season, this book shows why New Jersey is the Garden State.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rachel Weston\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("A native of the Jersey Shore, Rachel J. Weston is a food writer, chef and culinary instructor. She is committed to helping people understand their food system and how to make seasonally inspired meals for their families from foods produced locally. Her work appears regularly online at NJ.com and in print in the Star-Ledger, South Jersey Times, the Trenton Times and the Express-Times. Visit www.racheljweston.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0